/** @file Checkboxes renders a group of checkboxes that looks coherent with the form conponents. */
import * as constants from '@/components/Form/constants';
import { createChoiceComponent } from './factory';
/** @returns A typed multiple choice field component. */
export function createTypedCheckboxes() {
    return createChoiceComponent({
        name: constants.nameCheckboxes,
        /**
         * See `isEqual` in {@link module:factory.CreateChoiceComponentOptions}.
         *
         * @param currentValue Current value.
         * @param value Option value.
         * @returns True if the set contains the option value.
         */
        isEqual(currentValue, value) {
            return currentValue.has(value);
        },
        /**
         * Render input element for a single option.
         *
         * @param data See {@link module:factory.RenderOptionInputData}.
         * @returns Input node.
         */
        renderOptionInput({ checked, currentValue, descriptionId, emitInputEvent, name, optionData: { value, disabled }, ref, inputValueAttribute, }) {
            return (<input type="checkbox" aria-describedby={descriptionId} disabled={disabled} domProps={{ checked, value }} name={name} ref={ref} onInput={evt => {
                    const set = new Set(currentValue);
                    if (evt.target.checked) {
                        set.add(value);
                    }
                    else {
                        set.delete(value);
                    }
                    emitInputEvent(set);
                }} value={inputValueAttribute}/>);
        },
    });
}
/** A pre-made component that is ready to accept string as values. */
export const Checkboxes = createTypedCheckboxes();
